package pl.nickers.match3.ui

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp

@Composable
fun TouchTransparentDebugOverlay(
    phaseHistory: List<String>,
    modifier: Modifier = Modifier,
) {
    Box(
        modifier = modifier.padding(8.dp),
        contentAlignment = Alignment.TopStart,
    ) {
        Column(
            modifier = Modifier.background(Color.Black.copy(alpha = 0.5f)).padding(8.dp),
            horizontalAlignment = Alignment.Start,
        ) {
            phaseHistory.asReversed().forEachIndexed { index, phase ->
                Text(
                    text = if (index == 0) "► $phase" else "  $phase",
                    color = if (index == 0) Color.Yellow else Color.White,
                    fontSize = 12.sp,
                )
            }
        }
    }
}
